import $ from 'jquery'

const initializedPricingElements = new WeakSet();

export function checkout () {
  const pxRptElement = document.querySelector('px-rpt');
  if (!pxRptElement || initializedPricingElements.has(pxRptElement)) return;
  initializedPricingElements.add(pxRptElement);

  function discountCodeForProduct(product) {
    const discountedProducts = (pxRptElement.getAttribute('discount-products-ids') || '')
      .split(',').map(id => id.trim());
    return product.period === 'Yearly' && discountedProducts.includes(product.productId)
      ? pxRptElement.getAttribute('data-discount-code') || ''
      : '';
  }

  function redirectTo(url, loaderText){
    $('.loading-container__text').html(loaderText);
    $('#end-waypoint').addClass('-hidden');
    $('.loading-overlay').addClass('-visible');
    setTimeout(function(){
      $('.loading-container').addClass('-visible');
      $('.sale-banner').addClass('-hidden');
      setTimeout(function(){
        window.location.href = url;
      }, 900);
    }, 400);
  }

  function redirectToDashboard(priceId, experiment, productFamilyId, period, productName, productFamily, discountURI) {
    discountURI = (discountURI && discountURI !== '') ? discountURI : '';

    experiment = (experiment === 'yes') ? '&experiment=yes' : '';
    productFamilyId = (productFamilyId) ? '&product=' + productFamilyId : '';

    let checkoutURI = '&state=' + encodeURIComponent('/dashboard?a=checkout'  + productFamilyId + experiment + '&price=' + priceId + period + productName + productFamily + discountURI);

    redirectTo(
      window.px_config.pxDashboard.url.auth + checkoutURI,
      'Loading... <span>Please wait...</span>'
    );
  }

  function checkPeriod(period) {
    if (period === 'Yearly') {
      $('.pricing-container').addClass('-yearly');
      $('.pricing-container').removeClass('-monthly');
    } else {
      $('.pricing-container').removeClass('-yearly');
      $('.pricing-container').addClass('-monthly');
    }
  }

  pxRptElement.addEventListener('px-pricing-period-changed', (event) => {
    checkPeriod(event.detail);
  });
  checkPeriod(
    pxRptElement.shadowRoot?.querySelector('[role="switch"]')?.getAttribute('aria-checked') === 'false'
      ? 'Monthly'
      : pxRptElement.getAttribute('period') || 'Yearly'
  );

  // The initialization event can fire before the product prices are loaded.
  function updateTrialCurrency() {
    if (!pxRptElement.isConnected) {
      clearInterval(checkInterval);
      return;
    }

    const currency = pxRptElement.shadowRoot
      ?.querySelector('.pricing__plans .plan-card .price__symbol')?.textContent?.trim();
    if (!currency) return;

    $('.pricing-banner__plan__price__currency').text(currency);
    clearInterval(checkInterval);
  }

  const checkInterval = setInterval(updateTrialCurrency, 500);
  updateTrialCurrency();

  pxRptElement.addEventListener('px-pricing-initialised', (event) => {
    pxRptElement.shadowRoot.append(
      Object.assign(document.createElement('style'), {
        innerText : `
          .period-selector__label::first-letter {
            text-transform: uppercase;
          }
        `
      })
    );

  });

  // Listen for "Buy Now" button click
  pxRptElement.addEventListener('px-pricing-buy-now-click', (event) => {
    const auth_token = pxRptElement.getAttribute('jwt');
    const priceId = event.detail.id;
    const experiment = 'no';
    const productFamilyId = event.detail.productFamily;
    const period = event.detail.period;
    const productName = event.detail.productName;

    const periodURI = (period) ? '&period=' + encodeURIComponent(period) : '';
    const productNameURI = (productName) ? '&productName=' + encodeURIComponent(productName) : '';
    const productFamilyURI = (productFamilyId) ? '&productFamily=' + encodeURIComponent(productFamilyId) : '';
    const discountCode = discountCodeForProduct(event.detail);
    const discountURI = discountCode ? '&discount=' + encodeURIComponent(discountCode) : '';

    if (!auth_token) {
      redirectToDashboard(priceId, experiment, productFamilyId, periodURI, productNameURI, productFamilyURI, discountURI);
    }
  });

  // Listen for successful checkout
  pxRptElement.addEventListener('px-pricing-checkout-success', (event) => {
    const e = event.detail;
    const redirectLink = window.px_config.account_url +
      '/dashboard' +
      '?priceId=' + e.id +
      '&discountCode=' + encodeURIComponent(discountCodeForProduct(e) || 'undefined') +
      '&payment-success=true' +
      '&period=' + encodeURIComponent(e.period) +
      '&productName=' + encodeURIComponent(e.productName) +
      '&productFamily=' + encodeURIComponent(e.productFamily);

    window.location.href = redirectLink;
  });

  // Listen for successful upgrade
  pxRptElement.addEventListener('px-pricing-upgrade-success', (event) => {
    const e = event.detail;
    const redirectLink = window.px_config.account_url +
      '/dashboard' +
      '?priceId=' + e.id +
      '&discountCode=' + encodeURIComponent(discountCodeForProduct(e) || 'undefined') +
      '&payment-success=true' +
      '&period=' + encodeURIComponent(e.period) +
      '&productName=' + encodeURIComponent(e.productName) +
      '&productFamily=' + encodeURIComponent(e.productFamily);

    window.location.href = redirectLink;
  });
}
